import { render } from "./GameMenuView.vue?vue&type=template&id=1da3b2b6"
import script from "./GameMenuView.vue?vue&type=script&lang=js"
export * from "./GameMenuView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__